<template>
  <div class="content-page">
    <div class="inner">
      <zg-breadcrumb
        v-if="breadcrumbs.length"
        :bread-crumbs="breadcrumbs"
        text-color="white"
        class="breadcrumbs"
      />

      <h1
        v-if="title"
        v-html="title"
      />

      <div
        v-if="$slots['sub-title']"
        class="sub-title"
      >
        <slot name="sub-title" />
      </div>

      <div
        v-else-if="$slots['content']"
        class="content"
      >
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
  import ZgBreadcrumb from '../ZgBreadCrumb/ZgBreadCrumb'

  export default {
    name: 'ContentPage',
    components: {
      ZgBreadcrumb
    },
    props: {
      title: {
        type: String,
        required: false,
        default: null
      },
      breadcrumbs: {
        type: Array,
        required: false,
        default: null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content-page {
    position: relative;
    width: 100%;
    padding: rem(32px) rem(16px);

    .inner {
      max-width: rem(1080px);
      display: flex;
      flex-direction: column;
      margin: 0 auto;
    }

    .breadcrumbs {
      margin: 0 0 rem(12px);
    }

    h1 {
      @include type-title-xl;

      color: color(white);
      margin: 0;

      @include mq(medium) {
        @include type-title-xxl;

        margin: 0;
      }
    }

    .sub-title {
      @include type-title-m;

      color: color(white);
      font-weight: font-weight(bold);
      margin: rem(12px) 0 0;

      ::v-deep p {
        @include type-title-m;

        color: color(white);
        font-weight: font-weight(bold);
        margin: rem(12px) 0 rem(8px);

        &:last-child {
          margin: rem(12px) 0 0;
        }
      }
    }
  }
</style>
